import { Logger } from '@vue-storefront/core';
import { EXPONDO_MIDDLEWARE_ROUTES } from '~/constants/routes';
import { runExpondoMiddlewareRequest } from '~/helpers/middleware/runExpondoMiddlewareRequest';
import { AllowedMethods } from '~/types/expondoMiddleware';

export default async ({ route, redirect, $axios, $config, req }) => {
  try {
    const { data } = await runExpondoMiddlewareRequest({
      $axios,
      $config,
      endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.ROOT + EXPONDO_MIDDLEWARE_ROUTES.CT.IS_LOGGED_IN,
      method: AllowedMethods.post,
      headers: req?.headers,
    });
    if (!data) {
      throw new Error(`"${route.fullPath}" route is only available to logged-in customers`);
    }
  } catch (error) {
    Logger.warn(error.toString());
    return redirect('/');
  }
};
